function updateCartPrice() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.querySelectorAll('.cart-total-price').forEach(el => {
        el.textContent = Shopify.formatMoney(cart.total_price);
      });
    });
}

// When page loads
document.addEventListener('DOMContentLoaded', updateCartPrice);

// Listen for cart drawer updates (modern themes)
document.addEventListener('cart:updated', updateCartPrice);

// Backup trigger (when add to cart clicked)
document.addEventListener('click', function(e) {
  if (e.target.closest('form[action="/cart/add"]')) {
    setTimeout(updateCartPrice, 700);
  }
});